import React, { useState } from "react";
import { Draggable } from "react-beautiful-dnd";
import Baseurl from "../../../Baseurl";
import {
    Button,
    Modal,
  } from "react-bootstrap";
  import axios from "axios";
  import swal from "sweetalert";
  import { useHistory } from "react-router-dom";
function Task(props) {
  const { id, index, title, images,setTask,number,link,imageName,color } = props;
  const history=useHistory()
  const [name, setName] = useState("");
  const [catKey, setCatKey] = useState("");
  const [catUrl, setCatUrl] = useState("");
  const [image, setImage] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [show, setShow] = useState(false);
  const [deleteStatus, setDeleteStatus] = useState(false);
  const [updateStatus, setUpdateStatus] = useState(false);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [bannerId, setBannerId] = useState("");
  const [bannerCategory, setBannerCategory] = useState("");
  const [bannerImage, setBannerImage] = useState("");

  const onChangePicture = (e) => {
    setUploadStatus(true)
    if(e.target.files[0]&&e.target.files[0].size/1024<3000){ 
      
      if (e.target.files[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = function (val) {
          var image = new Image();
          image.src = val.target.result;
          image.onload = function () {
            var height = this.height;
            var width = this.width;
            setImage(e.target.files[0]);
              setBannerImage(reader.result);
            // if (height == 160 && width == 200) {
            //   setImage(e.target.files[0]);
            //   setBannerImage(reader.result);
            // }
            // else
            //   {
            //   swal("Oops", "image Width×Height should be 200×160", "error", {
            //     button: "Done",
            //     timer: 2000,
            //   });
            //   setBannerImage(null);
            //   return false;
            // }
          };
        };
      }
    }
    else
    {
      swal("Oops", "image size should be less than 200KB", "error", {
        button: "Done",
        timer: 2000,
      });
      setBannerImage(null)
    }
    
  };
  function getData() {
    axios.get(Baseurl.baseurl +`/go-ui/get-category`).then((res) => {
      setTask(res.data.categories)
    });
  }
  function deleteBanner(e) {
    e.preventDefault()
    axios
      .delete(Baseurl.baseurl + `/go-ui/delete-category/${id}`)
      .then((response) => {
        if (response.data.status) {
          getData();
          swal("Deleted", response.data.message, "success", { button: "Done",timer: 1000, });
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000, });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
  }
  function updateImage(e) {
    e.preventDefault();
    const data = new FormData();
    data.append("image", image);
    data.append("key", `${imageName}`);
    var config = {
      method: "put",
      url: `${Baseurl.baseurl}/go-ui/update-category-image/${id}`,
      data: data,
    };
    axios(config)
      .then(function(response) {
        if (response.data.status) {
          swal("Added", response.data.message, "success", { button: "Done",timer: 1000, });
          getData();
          setName("");
          setImage(null);
          setImageData(null);
        } else {
          swal("Oops", response.data.message, "error", { button: "Done" ,timer: 1000,});
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })

    setShow(false)
  }
  function updateCategoryFields(e) {
    e.preventDefault();
    let bannerData = {
      category:`${bannerCategory}`,
      key:catKey,
      url:catUrl
    };
    axios
      .put(
        Baseurl.baseurl + `/go-ui/update-category-fields/${bannerId}`,
        bannerData
      )
      .then((response) => {
        if (response.data.status) {
          getData();
          setName("");
          setImage(null);
          setImageData(null);
          swal("Added", response.data.message, "success", { button: "Done",timer: 1000, });
        } else {
          swal("Oops", response.data.message, "error", { button: "Done",timer: 1000, });
        }
      })
      .catch((err) => {
        if(err.toString()==="Error: Network Error")
        {
          history.push('/offline')
        }
        else
        {
          history.push('/400')
        }
    })
    setShow(false)
  }
  return (
      <>
      <Modal show={show} onHide={()=>{setShow(false)}}>
        <Modal.Body>
         {deleteStatus?(
           <h4>Are you sure !! you want to delete  <text className="text-danger ml-1">{bannerCategory}</text></h4>
         ):(
           <div className="card">
           <div className="card-body">
                  <div className="row ">
                    <div className="col-sm-4 mt-2">
                      <label>Category</label>
                    </div>
                    <div className="col-sm-8">
                      <input
                        type="text"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={bannerCategory}
                        onChange={(e) => setBannerCategory(e.target.value)}
                        placeholder="Enter Category Name"
                      />
                    </div>
                  </div>
                  <div className="row mt-4 ">
                    <div className="col-sm-4 mt-2">
                      <label>Category Key</label>
                    </div>
                    <div className="col-sm-8">
                      <input
                        type="number"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={catKey}
                        onChange={(e) => setCatKey(e.target.value)}
                        placeholder="Enter 2 digit Key"
                        maxLength={2}
                      />
                    </div>
                  </div>
                  <div className="row mt-4 ">
                    <div className="col-sm-4 mt-2">
                      <label>Category Url</label>
                    </div>
                    <div className="col-sm-8">
                      <input
                        type="url"
                        className="form-control"
                        id="val-username"
                        name="val-username"
                        value={catUrl}
                        onChange={(e) => setCatUrl(e.target.value)}
                        placeholder="Enter Url"
                      />
                    </div>
                  </div>
                  <div>
                    <button className="btn btn-primary mt-4" 
                     onClick={(e)=>{updateCategoryFields(e)}}
                    >Update</button>
                  </div>
                  <div className="row mt-4 ">
                    <div className="col-sm-4 mt-2">
                      <label className="col-form-label" htmlFor="val-range">
                        Category Image
                        <span className="text-danger">*</span>
                      </label>
                    </div>
                    <div className="col-sm-8">
                      <div className="register_profile_image mt-2">
                        <input
                          id="profilePic"
                          type="file"
                          onChange={(e) => {
                            onChangePicture(e);
                          }}
                        />
                      </div>
                      <small>image should be less than 200KB and size 150×200</small>
                      {bannerImage && (
                              <div
                                style={{
                                  marginTop: "5px",
                                  width: 180,
                                  height: 100,
                                  aspectRatio: 1 * 1.4,
                                }}
                                className="previewProfilePic"
                              >
                                <img
                                  alt=""
                                  className="playerProfilePic_home_tile"
                                  style={{
                                    resizeMode: "cover",
                                    width: "100%",
                                    height: "100%",
                                  }}
                                  src={bannerImage}
                                />
                              </div>
                            )}
                    </div>
                  </div>
                  <div>
                    <button className="btn btn-primary mt-4" onClick={(e)=>{updateImage(e)}}>Update Image</button>
                  </div>
                </div>
           </div>
         )}
        </Modal.Body>
        {deleteStatus&&(
           <Modal.Footer>
           <Button variant="primary" onClick={(e)=>{
               deleteBanner(e)
            }}>
               Delete
            </Button>
             <Button variant="secondary" onClick={()=>{setShow(false)}}>
               Close
             </Button>
           </Modal.Footer>
        )}
      </Modal>
    <Draggable draggableId={id} index={index} type="TASK">
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          <div className="card" style={{ padding:20, color: "white",background:"linear-gradient(90deg, #135334 0%, #98e7c1 100%)",}}>
            <div className="row">
              <div className="col-sm-2 mt-4">{title.replace('_',' ')}</div>
              <div className="col-sm-1 mt-4"><strong>{number}</strong></div>
              <div className="col-sm-3 mt-4">{link}</div>
              <div className=" mt-4" style={{backgroundColor:`#${color.toString(16).slice(2)}`,height:20,width:20}}></div>
              <div className="col-sm-3">
                <div
                  style={{
                    marginTop: "5px",
                    width: 180,
                    height: 100,
                    aspectRatio: 1 * 1.4,
                  }}
                  className="col-sm-12"
                >
                  <img
                    style={{
                      resizeMode: "cover",
                      width: "100%",
                      height: "100%",
                    }}
                    class="img-fluid"
                    alt=""
                    src={`${images}`}
                  />
                </div>
              </div>
              <div className=" mt-4">
                <button
                  onClick={() => {
                    setUploadStatus(false);
                    setBannerId(id);
                    setUpdateStatus(true);
                    setShow(true);
                    setBannerCategory(title);
                    setBannerImage(images);
                    setCatKey(number)
                    setCatUrl(link)
                    setDeleteStatus(false)
                   
                  }}
                  className="btn btn-primary float-right"
                >
                  Update
                </button>
              </div>
              <div className="ml-1 mt-4">
                <button
                  onClick={() => {
                    setShow(true);
                    setDeleteStatus(true)
                    setBannerCategory(title);
                  }}
                  className="btn btn-primary"
                >
                  delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Draggable>
    </>
  );
}

export default Task;
